type XhrLike = { response?: unknown };

type ProgressEventLike = {
  event?: { target?: XhrLike | null; currentTarget?: XhrLike | null } | null;
};

/**
 * Reads the accumulated response text from an axios download-progress event.
 *
 * Prefers `event.target` over `event.currentTarget`: axios throttles
 * onDownloadProgress and replays the stored event on a trailing-edge
 * setTimeout, by which point the browser has reset `currentTarget` to null.
 * `target` survives dispatch, so reading it avoids a null deref on the final
 * flush — the flush that carries the stream's trailing `meta` message.
 */
export function getXhrResponseText(progressEvent: ProgressEventLike): string | null {
  const xhr = progressEvent.event?.target ?? progressEvent.event?.currentTarget;
  const response = xhr?.response;
  return typeof response === 'string' ? response : null;
}
